import React, { createContext, useContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [shopType, setShopType] =  useState(null);

    useEffect(() => {
        const shopTypeFromStorage = localStorage.getItem("shop-type");
        if (shopTypeFromStorage !== null) {
            setShopType(shopTypeFromStorage); 
        }
    }, []);

    const updateShopType = (newShopType) => {
        localStorage.setItem("shop-type", newShopType);
        setShopType(newShopType);
    };

    return (
        <AuthContext.Provider value={{ shopType, setShopType, updateShopType }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);